<div class="loayout">
    <router-outlet></router-outlet>
</div>